import Configuration from '../config/Configuration';

import BeaconFilter from '../models/BeaconFilter';
import BeaconFilterItem from '../models/BeaconFilterItem';
//import BeaconFilterItemRequest from '../models/BeaconFilterItemRequest';

// TODO: remove test
//import jsonIndividualData from '../test/individuals.json';

function normalizeApiUrl(url: string) {
  return url.endsWith('/') ? url : `${url}/`;
}

const INTEGRATOR_API_ENDPOINT = normalizeApiUrl(
  Configuration.INTEGRATOR_API_ENDPOINT
);

//const ASSEMBLY_ID = Configuration.ASSEMBLY_ID;
const DEFAULT_GRANULARITY = 'record';

//let biosamplesIndividuals:any = {};

class VirusBeaconClient {
  public static readonly GRANULARIY_COUNT: string = 'count';

  public static readonly MAX_LIMIT = 999;
  public static readonly MIN_NUM_RESULTS = 100;

  static async getFilteringTerms(
    abortSignal: AbortSignal
  ): Promise<BeaconFilterItem[]> {
    const queryParams = {
      limit: VirusBeaconClient.MAX_LIMIT,
    };
    const endPoint = INTEGRATOR_API_ENDPOINT + 'filtering_terms';

    const response = await VirusBeaconClient.get<any>(
      endPoint,
      queryParams,
      abortSignal
    );
    return ((response.response || {}).filteringTerms ||
      []) as BeaconFilterItem[];
  }

  static async getFilteringTermsImg(
    abortSignal: AbortSignal
  ): Promise<BeaconFilterItem[]> {
    const queryParams = {
      limit: VirusBeaconClient.MAX_LIMIT,
    };
    const endPoint = INTEGRATOR_API_ENDPOINT + 'images/filtering_terms';

    const response = await VirusBeaconClient.get<any>(
      endPoint,
      queryParams,
      abortSignal
    );
    return ((response.response || {}).filteringTerms ||
      []) as BeaconFilterItem[];
  }

  static async getCountImage(
    filter: BeaconFilter,
    abortSignal: AbortSignal
  ): Promise<[boolean, number]> {
    const requestBody = {
      meta: {
        beaconId: Configuration.BEACON_ID,
        apiVersion: Configuration.BEACON_API_ID,
      },
      query: VirusBeaconClient.translateQuery(
        filter,
        VirusBeaconClient.GRANULARIY_COUNT
      ),
    };
    const endPoint = INTEGRATOR_API_ENDPOINT + 'occurrences';
    const response = await VirusBeaconClient.post<any>(
      endPoint,
      undefined,
      requestBody,
      abortSignal
    );

    if (!('responseSummary' in response)) {
      const error = new Error('Unrecognized response');
      error.name = '500';
      throw error;
    } else {
      const existsRx = (response.responseSummary || {}).exists || false;
      const numRx = (response.responseSummary || {}).numTotalResults || 0;
      return [existsRx, numRx];
    }
  }

  static async getVariants(
    filter: BeaconFilter,
    abortSignal: AbortSignal
  ): Promise<[boolean, number, any[]]> {
    const requestBody = {
      meta: {
        beaconId: Configuration.BEACON_ID,
        apiVersion: Configuration.BEACON_API_ID,
      },
      query: VirusBeaconClient.translateQuery(filter, DEFAULT_GRANULARITY),
    };
    const endPoint = INTEGRATOR_API_ENDPOINT + 'g_variants';
    const response = await VirusBeaconClient.post<any>(
      endPoint,
      undefined,
      requestBody,
      abortSignal
    );

    if (!('responseSummary' in response)) {
      const error = new Error('Unrecognized response');
      error.name = '500';
      throw error;
    } else {
      const existsVariants = (response.responseSummary || {}).exists || false;
      const numVariants = (response.responseSummary || {}).numTotalResults || 0;
      //const variants = ((response.response) || {}).resultSets[0].results || [];
      const variants =
        ((response.response || {}).resultSets || []).length > 0
          ? response.response.resultSets[0].results
          : [];
      // const maxNumVariants = !!(((response.response || {}).info || {}).numTotalResults || "");
      return [existsVariants, numVariants, variants];
    }
  }

  static async getCountIndividuals(
    filter: BeaconFilter,
    abortSignal: AbortSignal
  ): Promise<[number]> {
    return VirusBeaconClient.getIndividuals(
      filter,
      VirusBeaconClient.GRANULARIY_COUNT,
      abortSignal
    );
  }

  static async getIndividuals(
    filter: BeaconFilter,
    granularity: string,
    abortSignal: AbortSignal
  ): Promise<[number]> {
    const requestBody = {
      meta: {
        beaconId: Configuration.BEACON_ID,
        apiVersion: Configuration.BEACON_API_ID,
      },
      query: VirusBeaconClient.translateQuery(filter, granularity),
    };

    const endPoint = INTEGRATOR_API_ENDPOINT + 'individuals';

    const response = await VirusBeaconClient.post<any>(
      endPoint,
      undefined,
      requestBody,
      abortSignal
    );

    if (!('responseSummary' in response)) {
      const error = new Error('Unrecognized response');
      error.name = '500';
      throw error;
    } else {
      const existsIndividuals =
        (response.responseSummary || {}).exists || false;
      const numIndividuals =
        (response.responseSummary || {}).numTotalResults || 0;
      //const maxNumIndividuals = !!(((response.response || {}).info || {}).numTotalResults || "");
      //const individuals = DEFAULT_GRANULARITY === granularity ?
      //                        ((response.response) || {}).resultSets[0].results || []
      //                            : [];

      return [existsIndividuals, numIndividuals];
    }
  }

  static async getAllBiosamples(abortSignal: AbortSignal): Promise<[number]> {
    const queryParams = {
      // TODO:
      //limit: -1
      limit: 1000,
    };
    const endPoint = INTEGRATOR_API_ENDPOINT + 'biosamples';

    const response = await VirusBeaconClient.get<any>(
      endPoint,
      queryParams,
      abortSignal
    );

    if (!('responseSummary' in response)) {
      const error = new Error('Unrecognized response');
      error.name = '500';
      throw error;
    } else {
      const existsBiosamples = (response.responseSummary || {}).exists || false;
      const numBiosamples =
        (response.responseSummary || {}).numTotalResults || 0;
      //const maxNumBiosamples = !!(((response.response || {}).info || {}).numTotalResults || "");
      //const biosamples = ((response.response || {}).resultSets || []).length  > 0 ?  response.response.resultSets[0].results: []

      return [existsBiosamples, numBiosamples];
    }
  }

  private static translateQuery(query: BeaconFilter, granularity: string): any {
    const result: any = {
      requestedGranularity: granularity,
    };

    if (!!query && !!query.pagination && !!Object.keys(query.pagination)) {
      result.pagination = query.pagination;
    }

    if (
      !!query &&
      !!query.filtersImg &&
      Object.keys(query.filtersImg).length !== 0
    ) {
      result.filtersImg = query.filtersImg;
    }

    if (!!query && !!query.filters && Object.keys(query.filters).length !== 0) {
      result.filters = query.filters;
    }

    // if (!!query.variant || !!query.range || !!query.gene || !!query.aminoacidChange) {
    result.requestParameters = {
      //   assemblyId: `${ASSEMBLY_ID}`
    };
    if (!!query.variant && Object.keys(query.variant).length !== 0) {
      const pos = parseInt(query.variant.position);
      result.requestParameters = {
        ...result.requestParameters,
        referenceName: query.variant.sequence,
        // Base-0 webService
        //start: [pos-1],
        //end: [pos],
        start: [pos - 1, pos - 1],
        alternateBases: query.variant.alternate,
        referenceBases: query.variant.reference,
      };
    }
    if (!!query.range && Object.keys(query.range).length !== 0) {
      const rangeStart = parseInt(query.range.start);
      const rangeEnd = parseInt(query.range.end);
      result.requestParameters = {
        ...result.requestParameters,
        referenceName: query.range.sequence,
        // Base-0 webService
        start: [rangeStart - 1, rangeEnd - 1],
      };
    }
    if (!!query.gene && Object.keys(query.gene).length !== 0) {
      result.requestParameters = {
        ...result.requestParameters,
        geneId: query.gene,
      };
    }
    if (
      !!query.aminoacidChange &&
      Object.keys(query.aminoacidChange).length !== 0
    ) {
      result.requestParameters = {
        ...result.requestParameters,
        aminoacidChange: query.aminoacidChange,
      };
    }

    // }

    return result;
  }

  private static async exchange<T>(
    serviceUrl: string,
    httpMethod: string,
    queryParams: any,
    requestBody: any,
    abortSignal: AbortSignal
  ): Promise<T> {
    // const mmpHostUrl = clientConfig.get("mmp-host") as string;

    const headers = {
      Accept: 'application/json',
      'Content-Type': 'application/json',
    } as any;
    const params = {
      method: httpMethod,
      mode: 'cors',
      headers: headers,
      signal: abortSignal,
      body: undefined === requestBody ? undefined : JSON.stringify(requestBody),
    } as RequestInit;
    const queryStr =
      undefined === queryParams
        ? ''
        : Object.entries(queryParams)
            .filter(([paramName, paramValue]) => undefined !== paramValue)
            .map(([paramName, paramValue]) => {
              const value: string =
                paramValue instanceof Date
                  ? paramValue.toISOString()
                  : (paramValue as string);
              if (paramValue instanceof Array) {
                const paramsList = paramValue.map(
                  (x) =>
                    encodeURIComponent(paramName) + '=' + encodeURIComponent(x)
                );
                return paramsList.join('&');
              } else {
                return `${encodeURIComponent(paramName)}=${encodeURIComponent(
                  value
                )}`;
              }
            })
            .join('&');

    const queryUrl = `${serviceUrl}${!!queryStr ? '?' : ''}${queryStr}`;
    const response = await fetch(queryUrl, params);
    if (!!response.ok) {
      const actualResponse = await response.json();
      return actualResponse;
    } else {
      const error = new Error(response.statusText);
      error.name = `${response.status}`;

      throw error;
    }
  }

  private static async get<T>(
    serviceUrl: string,
    queryParams: any,
    abortSignal: AbortSignal
  ): Promise<T> {
    return VirusBeaconClient.exchange(
      serviceUrl,
      'GET',
      queryParams,
      undefined,
      abortSignal
    );
  }

  private static async put<T>(
    serviceUrl: string,
    queryParams: any,
    requestBody: any,
    abortSignal: AbortSignal
  ): Promise<T> {
    return VirusBeaconClient.exchange(
      serviceUrl,
      'PUT',
      queryParams,
      requestBody,
      abortSignal
    );
  }

  private static async post<T>(
    serviceUrl: string,
    queryParams: any,
    requestBody: any,
    abortSignal: AbortSignal
  ): Promise<T> {
    return VirusBeaconClient.exchange(
      serviceUrl,
      'POST',
      queryParams,
      requestBody,
      abortSignal
    );
  }

  private static async delete<T>(
    serviceUrl: string,
    queryParams: any,
    abortSignal: AbortSignal
  ): Promise<T> {
    return VirusBeaconClient.exchange(
      serviceUrl,
      'DELETE',
      queryParams,
      undefined,
      abortSignal
    );
  }
}

export default VirusBeaconClient;
